import Vue from 'vue';
import VueRouter from 'vue-router';
import Main from '../pages/user_main.vue';
import News from '../pages/news.vue';
import Partner from '../pages/partner.vue';
import Partners from '../pages/partners.vue';
import Category from '../pages/category.vue';
import GovAnnounces from '../pages/gov_announces.vue';
import GovAnnounce from '../pages/gov_announce_single.vue';
import HowToUse from '../pages/how_to_use.vue';
import Media from '../pages/media.vue';
import Vuex from '../store/store_user.js';
import { logout } from '../plugins/login.js';
import { unlockBody } from '../plugins/tool.js';

const state = Vuex.state;
Vue.use(VueRouter);

const routes = [
  {
    path: '',
    component: Main
  },
  {
    path: '/news',
    component: News
  },
  {
    path: '/partner',
    component: Partner
  },
  {
    path: '/partners',
    component: Partners
  },
  {
    path: '/category',
    component: Category
  },
  {
    path: '/gov-announces',
    component: GovAnnounces
  },
  {
    path: '/gov-announce',
    component: GovAnnounce
  },
  {
    path: '/how-to-use',
    component: HowToUse
  },
  {
    path: '/media',
    component: Media
  }
];

const router = new VueRouter({
  routes: routes,
  mode: process.env.VUE_APP_ROUTER_MODE
});

function setDateformat() {
  Date.prototype.yyyymmdd = function() {
    var mm = this.getMonth() + 1; // getMonth() is zero-based
    var dd = this.getDate();

    return [this.getFullYear(), mm, dd].join('-');
  };
}

function checkLoginStatus() {
  const identity = localStorage.getItem('identity');
  if (identity !== 'users' && identity !== null) logout(state);
}
/*
function addFakeData() {
  // A user for development
  localStorage.setItem(state.storageKeys.identity, 'users');
  localStorage.setItem(
    state.storageKeys.lastVisit,
    'https://fact-checker.line-beta.me/'
  );
  localStorage.setItem(
    state.storageKeys.id,
    'Uaac867eaa6d931aa3a3a8783d200394f'
  );
  localStorage.setItem(state.storageKeys.displayName, 'FakeUser');
  localStorage.setItem(
    state.storageKeys.token,
    '31b0f047540c5112b3a8edb2cfbad4511918b42367287dd0212d9c701c9cd937'
  );
  // localStorage.setItem(state.storageKeys.logoutUrl, "https://account.line-beta.biz/logout?code=sGQ7Y04N8HRdnD4otUDtJwEJA_KgKYo5nFC3ELtb1K0&redirectUri=https%3A%2F%2Fpartner-fact-checker.line-beta.biz")
}
*/
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  unlockBody()
  setDateformat()
  checkLoginStatus(to)
  // addFakeData()
  next()
})

export default router;
